import React, {useState} from 'react';
import PropTypes from 'prop-types';
import Stage1 from "./Stages/Stage1";
import Stage2 from "./Stages/Stage2";
import Stage3 from "./Stages/Stage3";
import {useTecRmi} from "../../../contexts/TecRmiContext";
import {useHistory} from "react-router-dom";
import appUserRoutes from "../../../appUserRoutes";
import {TAB_SERVICE_PROPOSAL} from "../../../views/UserViews/TecRmi/MainView";

const ServiceProposal = props => {
  const { showType, ident } = useTecRmi();
  const history = useHistory();
  const [stage, setStage] = useState(1)
  const [stage1Data, setStage1Data] = useState({
    mileage: props.mileage,
    firstRegistrationDate: props.firstRegistrationDate,
    cooGroupId: props.cooGroupId,
    serviceProposalOption: props.serviceProposalOption,
  })
  const [stage2Data, setStage2Data] = useState({
    mainWorkId: props.mainWorkId,
    additionalWorkIds: props.additionalWorkIds,
  })
  const [stage3Data, setStage3Data] = useState(null)

  const handlePrevStage = () => {
    setStage(stage => stage-1)
  }
  const handleNextStage = () => {
    setStage(stage => stage+1)
  }

  const getPath = (stage1Data, stage2Data) => {
    const params = [
      stage1Data.mileage,
      stage1Data.firstRegistrationDate,
      stage1Data.cooGroupId,
      stage1Data.serviceProposalOption
    ]

    if(stage2Data?.mainWorkId){
      params.push(stage2Data.mainWorkId)
    }
    if(stage2Data?.additionalWorkIds?.length > 0){
      params.push(stage2Data.additionalWorkIds.join(','))
    }


    return appUserRoutes.tecRmi.tab(ident, TAB_SERVICE_PROPOSAL, params.join('/'))
  }

  return (
    <div>
      {stage === 1 && <Stage1
        initialData={stage1Data}
        onDataChange={setStage1Data}
        nextStage={() => setStage1Data(stage1Data => {
          if(!props.disableRedirects){
            history.push(getPath(stage1Data, stage2Data))
          }
          handleNextStage()

          return stage1Data
        })}
      />}
      {stage === 2 && <Stage2
        initialData={stage2Data}
        data={stage1Data}
        onDataChange={setStage2Data}
        prevStage={() => {
          if(!props.disableRedirects){
            history.push(appUserRoutes.tecRmi.tab(ident, TAB_SERVICE_PROPOSAL, [stage1Data.mileage, stage1Data.firstRegistrationDate, stage1Data.cooGroupId].join('/')))
          }

          setStage1Data({
            ...stage1Data,
            serviceProposalOption: null,
          })

          handlePrevStage()
        }}
        nextStage={() => {
          setStage2Data(stage2Data => {
            if(!props.disableRedirects){
              history.push(getPath(stage1Data, stage2Data))
            }

            handleNextStage()

            return stage2Data
          })
        }}
      />}
      {stage === 3 && <Stage3
        bodyQualColId={stage1Data.bodyForMaintenances}
        data={stage2Data}
        onDataChange={setStage3Data}
        prevStage={handlePrevStage}
      />}
    </div>
  );
};

ServiceProposal.defaultProps = {
  disableRedirects: false,
  mileage: null,
  firstRegistrationDate: '',
  cooGroupId: null,
  serviceProposalOption: '',
  mainWorkId: null,
  additionalWorkIds: [],
};

ServiceProposal.propTypes = {
  disableRedirects: PropTypes.bool,
  mileage: PropTypes.number,
  firstRegistrationDate: PropTypes.string,
  cooGroupId: PropTypes.number,
  serviceProposalOption: PropTypes.string,
  mainWorkId: PropTypes.number,
  additionalWorkIds: PropTypes.array,
};

export default ServiceProposal;